module.exports = __webpack_public_path__ + "img/step-3.6d769a4e.gif";